import { OverlayRef } from '@angular/cdk/overlay';
import { Observable, Subject } from 'rxjs';

export class PopoverRef {
  readonly #overlayRef: OverlayRef;
  readonly #afterClosed$ = new Subject<void>();

  constructor(overlayRef: OverlayRef) {
    this.#overlayRef = overlayRef;
  }

  public afterClosed$(): Observable<void> {
    return this.#afterClosed$.asObservable();
  }

  public close(): void {
    this.#overlayRef.detach();
    this.#afterClosed$.next();
    this.#afterClosed$.complete();
  }
}
